import { createContext, useContext, useEffect, useState } from 'react';
import { doc, getDoc, setDoc, collection, getDocs } from 'firebase/firestore';
import { onAuthStateChanged, signInWithPopup, signOut } from 'firebase/auth';
import { db, auth, googleProvider, normalizeProduct } from '@/lib/firebase';

const SiteContext = createContext({});

const defaultSettings = {
  companyName: 'AyzPlastik',
  slogan: 'Kalitenin Adı',
  phone: '05542345454',
  email: 'info@ayzplastics.com',
  instagram: 'https://www.instagram.com/ayzplastik',
  whatsapp: '905542345454',
};

export function SiteProvider({ children }) {
  const [settings, setSettings] = useState(defaultSettings);
  const [heroSlides, setHeroSlides] = useState([]);
  const [allProducts, setAllProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  // --- YENİ: AUTH STATE ---
  const [user, setUser] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);

  // --- YENİ: SEPET STATE ---
  const [cart, setCart] = useState([]);

  // 1. Uygulama Başladığında Verileri ve Auth Durumunu Çek
  useEffect(() => {
    // Sepeti Yerel Depolamadan Yükle
    const savedCart = localStorage.getItem('ayz_cart');
    if (savedCart) setCart(JSON.parse(savedCart));

    // Auth Dinleyicisi
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setAuthLoading(false);
    });

    const fetchAll = async () => {
      try {
        const settingsDoc = await getDoc(doc(db, 'site_config', 'settings'));
        if (settingsDoc.exists()) setSettings({ ...defaultSettings, ...settingsDoc.data() });

        const productsSnap = await getDocs(collection(db, 'urunler'));
        const products = productsSnap.docs.map((d) => normalizeProduct(d));
        setAllProducts(products);

        const heroDoc = await getDoc(doc(db, 'site_config', 'hero_slides'));
        if (heroDoc.exists() && heroDoc.data().productIds?.length > 0) {
          const ids = heroDoc.data().productIds;
          const slides = ids.map((id) => products.find((p) => p.id === id)).filter(Boolean);
          setHeroSlides(slides.length > 0 ? slides : products.slice(0, 3));
        } else {
          setHeroSlides(products.slice(0, 3));
        }
      } catch (err) {
        console.error('Fetch error:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchAll();
    return () => unsubscribe();
  }, []);

  // 2. Sepet Değiştiğinde Yerel Depolamaya Kaydet
  useEffect(() => {
    localStorage.setItem('ayz_cart', JSON.stringify(cart));
  }, [cart]);

  // --- AUTH FONKSİYONLARI ---
  const loginWithGoogle = async () => {
    try {
      await signInWithPopup(auth, googleProvider);
    } catch (err) {
      console.error("Giriş hatası:", err);
    }
  };

  const logout = async () => {
    try {
      await signOut(auth);
    } catch (err) {
      console.error("Çıkış hatası:", err);
    }
  };

  // --- SEPET FONKSİYONLARI ---
  const addToCart = (product, quantity = 1) => {
    setCart((prev) => {
      const existing = prev.find((item) => item.id === product.id);
      if (existing) {
        return prev.map((item) =>
          item.id === product.id ? { ...item, quantity: item.quantity + quantity } : item
        );
      }
      return [...prev, { ...product, quantity }];
    });
  };

  const removeFromCart = (productId) => {
    setCart((prev) => prev.filter((item) => item.id !== productId));
  };

  const updateCartQuantity = (productId, delta) => {
    setCart((prev) =>
      prev.map((item) =>
        item.id === productId 
          ? { ...item, quantity: Math.max(1, item.quantity + delta) } 
          : item
      )
    );
  };

  const clearCart = () => setCart([]);

  const cartTotal = cart.reduce((sum, item) => sum + (item.price * item.quantity), 0);
  const cartCount = cart.reduce((sum, item) => sum + item.quantity, 0);

  return (
    <SiteContext.Provider value={{
      settings, heroSlides, allProducts, loading,
      user, authLoading, loginWithGoogle, logout,
      cart, addToCart, removeFromCart, updateCartQuantity, clearCart, cartTotal, cartCount,
      updateSettings: async (newS) => { /* Mevcut kodun... */ },
      updateHeroSlides: async (ids) => { /* Mevcut kodun... */ }
    }}>
      {children}
    </SiteContext.Provider>
  );
}

export function useSite() {
  return useContext(SiteContext);
}